export default __webpack_public_path__ + "372177be86060f84e5631af0a8164ef3.png";